import React from "react";
import { DropdownLink } from "components/layout/nav/dropdownLink";
import { NavLink } from "components/layout/nav/navLink";
import "./TabletNav.scss";
import { Stack } from "@mui/material";

function TabletNav() {
  return (
    <div className="tabletNav">
      <Stack spacing="xsmall">
        <NavLink label="Home" to="/" />
        <NavLink label="Register" to="/register" />
        <DropdownLink
          label="About"
          links={[
            { label: "Purpose", to: "/about/purpose" },
            { label: "Trustees", to: "/about/trustees" },
            { label: "Guidelines", to: "/about/guidelines" },
          ]}
        />
        <NavLink label="History" to="/history" />
        <NavLink label="Store" to="/store" />
        <NavLink label="Gallery" to="/gallery" />
        <DropdownLink
          label="PBH"
          links={[
            { label: "About", to: "/pbh/about" },
            { label: "Search", to: "/pbh/search" },
          ]}
        />
        <NavLink label="Donate" to="/donate" />
        <NavLink label="Contact" to="/contact" />
      </Stack>
    </div>
  );
}

export default TabletNav;
